import momentTimezone from 'moment-timezone';

export function convertTimeToLocalTime(timeZone, time, format, printFormat){
    return momentTimezone.tz(time, format, timeZone).clone().tz(momentTimezone.tz.guess()).format(printFormat)
}

export function convertDateTimeToLocalTime(timeZone, date){
    return momentTimezone(date).clone().tz(timeZone);
}